import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import type { VisualTopImageProps } from './VisualTopImage.types'

export const VisualTopImage = ({ title }: VisualTopImageProps): JSX.Element => {
  return (
    <VisuallyHidden.Root>
      <span>{title}</span>
    </VisuallyHidden.Root>
  )
}
